import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-duplicate-destination-dialog',
    templateUrl: './duplicate-destination-dialog.component.html',
    styleUrl: './duplicate-destination-dialog.component.css',
    standalone: false,
})
export class DuplicateDestinationDialogComponent {
    location: string;
    destination: any;

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: {
            options: any[];
        },
        private dialogRef: MatDialogRef<DuplicateDestinationDialogComponent>
    ) {}

    closeDialog() {
        this.dialogRef.close();
    }

    save() {
        if (this.isSaveDisabled()) return;
        this.dialogRef.close(this.destination);
    }

    handleDestinationChange(event) {
        this.destination = event.value;
    }

    isSaveDisabled() {
        if (!this.destination) return true;
        return false;
    }
}
